import { validate as isUuid } from 'uuid'

import { routes } from '@cedarjs/router'

/** Query param for deep-linking to a saved table view on the staff tasks list. */
export const TASKS_LIST_VIEW_UUID_QUERY_PARAM = 'viewUuid'

export const parseTasksListViewUuidFromSearch = (search: string): string | null => {
  const raw = new URLSearchParams(search).get(TASKS_LIST_VIEW_UUID_QUERY_PARAM)?.trim()
  if (!raw || !isUuid(raw)) {
    return null
  }
  return raw
}

export const tasksListPathWithViewUuid = ({ viewUuid }: { viewUuid: string }) => {
  const path = routes.tasks()
  const params = new URLSearchParams({ [TASKS_LIST_VIEW_UUID_QUERY_PARAM]: viewUuid })
  return `${path}?${params.toString()}`
}
